import { render } from "./App.vue?vue&type=template&id=878df284&bindings={\"mobileNavIsVisible\":\"setup\",\"setMobileNavVisibility\":\"setup\",\"showHideNav\":\"setup\",\"visibleRoutes\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script